import React, { useState, useMemo, useCallback, useEffect } from 'react';
import styled from './index.module.scss';
import Header from './Answer/ExamHeader';
import Footer from './Answer/ExamFooter';
import RadioComponent from './Answer/Form/RadioComponent';
import CheckboxComponent from './Answer/Form/CheckboxComponent';
import NextImage from '@/components/NextImage';
import { useQuestionStore, useQuestionDispatch } from '@/components/AppreciationDay/Questions/QuestionProvider';
import { useGlobal } from '@/utils/useGlobal';
import { IQuestionInfo, QType } from '@/components/AppreciationDay/index.d';

interface AnswerProps {
    finshed: () => void;
}

const Answer: React.FC<AnswerProps> = ({ finshed }) => {
    const { useLang, useRouter, isMobile } = useGlobal();
    const { locale } = useRouter();
    const { question, index, questionInfo } = useQuestionStore();
    const { questionType, questionName, analysisCorrect, analysisWrong, answerCorrect, optionList, defAnswer, userAnswer, questionId, picUrl } =
        question[index];
    const dispatch = useQuestionDispatch();
    const { t } = useLang('appreciationday');
    const [answer, setAnswer] = useState(userAnswer || '');

    useEffect(() => {
        setAnswer(userAnswer || '');
    }, [userAnswer]);

    const contentHtml = useMemo(() => {
        switch (questionType) {
            case QType.SINGLE:
                return <RadioComponent opstions={optionList} t={t} onChange={(val) => setAnswer(val)} isMobile={isMobile} />;
            case QType.MULTIPLE:
                return <CheckboxComponent opstions={optionList} t={t} onChange={(val) => setAnswer(val)} isMobile={isMobile} />;
            default:
                return <></>;
        }
    }, [index]);

    const formatOptionList = () => {
        return answer.split(',').map((item) => {
            const target = optionList.find((optItem) => optItem.optionId === item);
            return {
                optionId: target?.optionId,
                optionSelect: target?.optionSelect,
            };
        });
    };

    const getCorrectAns = (defAnswer: string) =>
        defAnswer
            .split(',')
            .map((item) => optionList.find((optItem) => item === optItem.optionId)?.optionSelect)
            .join(',');

    const submit = () => {
        if (defAnswer) return;
        const { campaignId, questionGroupId } = questionInfo as IQuestionInfo;
        const data = {
            answerFinish: index === question.length - 1,
            campaignId,
            optionList: formatOptionList(),
            questionGroupId,
            questionId,
        };
        dispatch({
            type: 'saveAnswer',
            payload: {
                data,
                locale,
                question,
                index,
            },
        });
    };

    const typeText = useCallback(() => {
        switch (questionType) {
            case QType.SINGLE:
                return t('question.single');
            case QType.MULTIPLE:
                return t('question.multiple');
            default:
                break;
        }
    }, [index]);

    return (
        <div className="content">
            <Header />
            <div className={styled.exam_content}>
                <div className="type">[{typeText()}]</div>
                <p className="title">{questionName}</p>
                {picUrl && (
                    <div className="img">
                        <NextImage src={picUrl} alt={t('banner.title')} aria-label={t('banner.title')} />
                    </div>
                )}
                {contentHtml}
                {defAnswer ? (
                    <div className="resolve">
                        <p>
                            {t('question.correct')} {getCorrectAns(defAnswer)}
                        </p>
                        {/* 正确且有正确答案｜｜错误且有错误答案 才显示解析 */}
                        {((answerCorrect && analysisCorrect) || (!answerCorrect && analysisWrong)) &&
                            `${t('question.analysis')}: ${answerCorrect ? analysisCorrect : analysisWrong}`}
                    </div>
                ) : (
                    <></>
                )}
            </div>
            <Footer submit={submit} finshed={finshed} answer={answer} />
        </div>
    );
};

export default Answer;
